import React, { useState, useEffect } from 'react';
import { useAuth } from "../../../Context/store/context";
import globals from '../../../../globals'
import { IconPlus } from '@tabler/icons-react';
import ApplicationForm from './ApplicationForm';
import axios from 'axios';

const Application = () => {
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [application, setApplication] = useState([]);
  
  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.Application.title, globals.Application.icon);
  }, []);
  const toggleDialog = (roolId = null) => {
    // const matchedRool = roolSection.find((rool) => rool.roolId === roolId);
    // setSelectedRoolId(matchedRool);
    setIsDialogOpen(true);
    fetchRools();

  };
  const closeDialog = () => {
    setIsDialogOpen(false);
    // setSelectedRoolId(null);
    fetchRools();
  };
  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getapplication`);
      console.log(response.data.application);

      if (Array.isArray(response.data.application)) {
        setApplication(response.data.application);
      } else {
        setApplication([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setApplication([]); // Handle error case
    }
  };


  useEffect(() => {
    fetchRools();
  }, []);
  return (
    <div style={{ padding: "2%" }}>
      <div className="container-xxl container-p-y bs-stepper wizard-vertical wizard-numbered vertical mt-2 content-header mb-3 d-flex justify-content-between">
        <div className="sec-titler">
          <h2 className="text-primary">Create Application</h2>
          <div className="title-shape"></div>
        </div>
        <div className="mb-0 text-right">
          <button className="btn btn-primary align-middle" onClick={toggleDialog}>
            <IconPlus className="me-sm-1 me-0" size={20} />
            Create Application
          </button>
        </div>
      </div>
      <div className="content-wrapper">
  <div className="container-xxl flex-grow-1 container-p-y">
    <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
      <div className="w-100 mb-4">
        <div className="w-100 gap-4 gap-md-0 justify-content-start mb-3 row">
          {application.map((app) => (
            <div key={app.applicationId} className="fotoowl-plan col-md-6 col-xl-3">
              <div className="main-card h-100 position-relative card">
                <div className="px-1 px-md-3 card-body text-center">
                  <div>
                    <h4>
                      <strong>{app.applicationname}</strong>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>

      {isDialogOpen && (
         <ApplicationForm  onClose={closeDialog} />
      )}
      </div>
  )
}

export default Application